import type { Theme } from '@mui/material';
import { differenceInDays } from 'date-fns';
import { AlertPriority } from 'src/@types/global-alert';

export const priorityColors = (theme: Theme) => ({
  [AlertPriority.LOWEST]: {
    background: theme.palette.grey[400],
    color: theme.palette.text.secondary,
  },
  [AlertPriority.LOW]: {
    background: theme.palette.info.main,
    color: theme.palette.text.primary,
  },
  [AlertPriority.MEDIUM]: {
    background: theme.palette.warning.main,
    color: theme.palette.text.primary,
  },
  [AlertPriority.HIGH]: {
    background: theme.palette.error.main,
    color: theme.palette.text.primary,
  },
  [AlertPriority.URGENT]: {
    background: theme.palette.error.dark,
    color: theme.palette.text.primary,
  },
  [AlertPriority.CRITICAL]: {
    background: theme.palette.error.darker,
    color: theme.palette.text.primary,
  },
});

export const colorsByExpirationTime = (theme: Theme, date: string) => {
  let priority: AlertPriority = AlertPriority.LOWEST;

  if (date) {
    const diff = differenceInDays(new Date(), new Date(date));

    if (diff >= 1) priority = AlertPriority.LOW;
    if (diff >= 3) priority = AlertPriority.MEDIUM;
    if (diff >= 5) priority = AlertPriority.HIGH;
  }

  const { background, color } = priorityColors(theme)[priority];
  return { background, color };
};
